import { IconMailPlus } from '@tabler/icons-react';
import { useCompanyConfiguration } from 'init/use-company-configuration';
import { i18nKeys } from 'locales/source/i18nKeys';
import type { InvoiceAction, UnhandledInvoice } from 'modules/AtRisk/api/use-load-unhandled-client';
import type { ActionButtonDefinition } from '../action-button-definition';
import { useSendAdditionalReminder } from '../api/use-send-additional-reminder';
import { useReminderWizardAction } from './use-reminder-wizard-action';

export function useAdditionalReminder(): (
  action: InvoiceAction,
  invoices: Array<UnhandledInvoice>,
) => ActionButtonDefinition {
  const { default_templates } = useCompanyConfiguration();
  const { sendAdditionalReminder } = useSendAdditionalReminder();

  return useReminderWizardAction({
    documentType: 'additional_reminder',
    translationKey: i18nKeys.TEMPLATE_TYPES.ADDITIONAL_REMINDER,
    icon: <IconMailPlus size={18} />,
    templateId: default_templates.additional_reminder.id?.toString() ?? '',
    send: sendAdditionalReminder,
  });
}
